// =====================================================================
// Teléfonos con código de país. Compartido por API y web.
// =====================================================================

/**
 * Resultado de normalizar un teléfono: o el número completo en dígitos
 * (formato internacional sin símbolos) o un error legible para el panel.
 */
export type PhoneNormalization = { ok: true; phone: string } | { ok: false; error: string };

/** Prefijos de área de República Dominicana (NANP). */
const RD_AREA = /^(809|829|849)/;

/**
 * Normaliza un teléfono a formato internacional en dígitos. Nace del bug que
 * dejó TODOS los avisos internos yendo al vacío: "8293375450" sin el 1 se
 * convierte en JID de WhatsApp de Corea del Sur (+82) — un número inexistente
 * al que el servidor "envía" sin error.
 *
 * Reglas:
 *  - 10 dígitos que empiezan por 809/829/849 (RD) → se antepone el 1 solo.
 *  - 11 a 15 dígitos → se aceptan tal cual (internacional completo).
 *  - Cualquier otra cosa → rechazo con mensaje claro (no se adivina el país).
 */
export function normalizeAvisoPhone(raw: string): PhoneNormalization {
  const digits = raw.replace(/\D/g, '');
  if (digits.length === 10 && RD_AREA.test(digits)) {
    return { ok: true, phone: `1${digits}` };
  }
  if (digits.length >= 11 && digits.length <= 15) {
    return { ok: true, phone: digits };
  }
  return {
    ok: false,
    error: 'El teléfono necesita el código de país (ej. 18295550000)',
  };
}
